__turbopack_context__.v({
  "altCurrency": "ExchangeRateInput-module__HwuOiq__altCurrency",
  "altCurrencyIcon": "ExchangeRateInput-module__HwuOiq__altCurrencyIcon",
  "altCurrencyLabel": "ExchangeRateInput-module__HwuOiq__altCurrencyLabel",
  "error": "ExchangeRateInput-module__HwuOiq__error",
});
